import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Col, Empty, Row, Space } from 'antd';
import { useUIDispatchContext } from 'providers/UI';
import { Link, useParams } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { PlusOutlined, UploadOutlined } from '@ant-design/icons';
import { GET_APPOINTMENT_WITH_REPORT } from 'gql/reports/queries';
import { AppointmentsWithReport } from 'gql/reports/__generated__/AppointmentsWithReport';

import { StyledEmptyCard } from './styled';
import { ReportCard, ReportFileCard } from 'components/shared';

const Reports: FC = () => {
  const { t } = useTranslation();
  const params = useParams();
  const { toggleModal } = useUIDispatchContext();

  const { data: appointmentReport } = useQuery<AppointmentsWithReport>(
    GET_APPOINTMENT_WITH_REPORT,
    {
      fetchPolicy: 'cache-and-network',
      nextFetchPolicy: 'cache-first',
      variables: {
        query: {
          appointment_id: params.id,
          pagination: {
            page: 0,
            limit: 999
          }
        }
      }
    }
  );

  const appointment = appointmentReport?.appointmentsWithReport.data.results[0];

  if (appointment?.report) {
    return (
      <Row>
        <Col span={12}>
          <ReportCard
            id={appointment.report.id}
            appointmentId={params.id || ''}
            dateReport={appointment.report.date_report}
            report={appointment.report.report}
            status={appointment.report.status}
          />
        </Col>
      </Row>
    );
  }

  if (appointment?.reports_file) {
    return (
      <Row>
        <Col span={12}>
          <ReportFileCard
            id={appointment.reports_file.id}
            date={appointment.reports_file.created_at}
            file={appointment.reports_file.file}
            note={appointment.reports_file.note}
          />
        </Col>
      </Row>
    );
  }

  return (
    <StyledEmptyCard>
      <Empty
        imageStyle={{
          height: 60
        }}
        description={<span>{t('appointments_details.no_report')}</span>}
      >
        <Space size={16}>
          <Button
            type="primary"
            ghost
            onClick={() =>
              toggleModal('appointmentReport', true, {
                id: params.id as string
              })
            }
          >
            <UploadOutlined />
            {t('reports.upload_report')}
          </Button>
          <div>
            <Link to={`/report/details?id=${params.id}`}>
              <Button type="primary">
                <PlusOutlined />
                {t('appointments_details.add_report')}
              </Button>
            </Link>
          </div>
        </Space>
      </Empty>
    </StyledEmptyCard>
  );
};

export default Reports;
